/**
 * Mirrors eatsbitsdesktop OrdersListController.hasBatchOperationsAccess:
 * owners (ROLE_ADMIN) and managers (ROLE_MANAGER).
 */
export function hasBatchOperationsAccess(userRole: string | null | undefined): boolean {
  return userRole === "ROLE_ADMIN" || userRole === "ROLE_MANAGER";
}
